// yogi
// http://localhost:8080/allForm/addOutstanding
// - start month + 3 month dari bulan skrg
// - payment total = total outstanding fee + late payment total
// - late payment total = late payment * total month

// paradigm sales 1
// http://localhost:8080/ptSessionBuy/add
// - tambahin dropdown - payment type ['regular', 'installment'] -> auto
// - kalau installment - installment month ['3', '6', '12']

// superadmin
// http://localhost:8080/memberEntry/edit?id=2202
// - tambahin action button send email
// - /transaction/send_invoice_name_type
// - trx_id POST

import axios from 'axios'

// const apiUrl = 'https://stg-api.paradigmfitnessindonesia.com/'
const apiUrl = process.env.VUE_APP_API_URL

const login = function (data) {
  return axios.post('vendor/v1/auth/login', data).then(res => { return res.data })
}

const Session = {
  delete: function (item) {
    if (!item) {
      localStorage.removeItem('paradigm_token')
      localStorage.removeItem('paradigm_session')
      localStorage.removeItem('paradigm_id')
      localStorage.removeItem('paradigm_role')
      localStorage.removeItem('paradigm_access_menu')
      localStorage.removeItem('paradigm_access_menu_permission')
      localStorage.removeItem('paradigm_username')
      localStorage.removeItem('paradigm_login_name')
      localStorage.removeItem('paradigm_app_menus')
      localStorage.removeItem('paradigm_cached_menus')
      localStorage.removeItem('paradigm_cached_selected_menu')
    } else {
      localStorage.removeItem(item)
    }
  },
  create: function (session) {
    localStorage.setItem('paradigm_token', session.token)
    localStorage.setItem('paradigm_session', session.session)
    if(session.sales_id && session.customer_service_id == null && session.personal_trainer_id == null && session.coach_id == null) {
      localStorage.setItem('paradigm_id', session.sales_id.id)
      localStorage.setItem('paradigm_branch_id', session.sales_id.branch_id)
    } else if (session.sales_id == null && session.customer_service_id && session.personal_trainer_id == null && session.coach_id == null) {
      localStorage.setItem('paradigm_id', session.customer_service_id.id)
      localStorage.setItem('paradigm_branch_id', session.customer_service_id.branch_id)

    } else if (session.sales_id == null && session.customer_service_id == null && session.personal_trainer_id && session.coach_id == null) {
      localStorage.setItem('paradigm_id', session.personal_trainer_id.id)
      localStorage.setItem('paradigm_branch_id', session.personal_trainer.branch_id)
    } else if (session.sales_id == null && session.customer_service_id == null && session.personal_trainer_id && session.coach_id) {
      localStorage.setItem('paradigm_id', session.personal_trainer_id.id)
      localStorage.setItem('paradigm_branch_id', session.personal_trainer.branch_id)
    } else if (session.sales_id == null && session.customer_service_id == null && session.personal_trainer_id == null && session.coach_id) {
      localStorage.setItem('paradigm_id', session.coach_id.id)
      localStorage.setItem('paradigm_branch_id', session.coach_id.branch_id)

    } else if (session.sales_id == null && session.customer_service_id == null && session.personal_trainer_id == null && session.coach_id == null && session.user_id) {
      localStorage.setItem('paradigm_id', session.user_id)
    } else {
      let obj = { sales_id: session.sales_id.id, customer_service_id: session.customer_service_id.id, personal_trainer_id: session.personal_trainer_id.id, coach_id: session.coach_id.id }
      let arrayParadigmId = Object.assign({}, obj)
      localStorage.setItem('paradigm_id', arrayParadigmId)
    }
    localStorage.setItem('paradigm_role', session.user_role[0].user_role_id)
    localStorage.setItem('paradigm_access_menu', session.user_access_menu_id)
    localStorage.setItem('paradigm_access_menu_permission', JSON.stringify(session.user_access_menu_permission))
    localStorage.setItem('paradigm_role_mapping_id', session.user_role_mapping_id)
    localStorage.setItem('paradigm_user_id', session.user_id)
    localStorage.setItem('paradigm_username', session.email)
    localStorage.setItem('paradigm_login_name', session.login_name)
    localStorage.setItem('paradigm_app_menus', JSON.stringify(session.app_menus))
    localStorage.setItem('paradigm_cached_selected_menu', session.paradigm_cached_selected_menu)
    if (session.personal_trainer == null) {
      localStorage.setItem('personal_trainer_is_spv', 0)
      localStorage.setItem('personal_trainer_is_mgr', 0)
    } else {
      localStorage.setItem('personal_trainer_is_spv', session.personal_trainer.is_supervisor)
      localStorage.setItem('personal_trainer_is_mgr', session.personal_trainer.is_manager)
    }
  },
  get: function (item) {
    if (!item) {
      let session = {
        paradigm_token: localStorage.getItem('paradigm_token'),
        paradigm_session: localStorage.getItem('paradigm_session'),
        paradigm_id: localStorage.getItem('paradigm_id'),
        paradigm_user_id: localStorage.getItem('paradigm_user_id'),
        paradigm_role: localStorage.getItem('paradigm_role'),
        paradigm_access_menu: localStorage.getItem('paradigm_access_menu'),
        paradigm_access_menu_permission: localStorage.getItem('paradigm_access_menu_permission'),
        paradigm_role_mapping_id: localStorage.getItem('paradigm_role_mapping_id'),
        paradigm_username: localStorage.getItem('paradigm_username'),
        paradigm_login_name: localStorage.getItem('paradigm_login_name'),
        paradigm_branch_id: localStorage.getItem('paradigm_branch_id'),
        personal_trainer_is_spv: localStorage.getItem('personal_trainer_is_spv'),
        personal_trainer_is_mgr: localStorage.getItem('personal_trainer_is_mgr'),
        paradigm_app_menus: localStorage.getItem('paradigm_app_menus'),
        paradigm_cached_selected_menu: localStorage.getItem('paradigm_cached_selected_menu')
      }
      return session
    } else {
      return localStorage.getItem(item)
    }
  }
  // getAuth () {
  //   return {
  //     elapor_token: localStorage.getItem('elapor_token')
  //   }
  // }
}

// validate permission to create, update, delete
const hasPermission = () => {
  // get user role id
  let role = Session.get('paradigm_role')

  // disabled
  if (role == 33) return true
  return false
}

export {
  Session,
  login,
  apiUrl,
  hasPermission
}
